module.exports = __webpack_public_path__ + "img/kund2.ed29c129.jpg";